export var DEFAULT_METERS = 3000;
export var DEFAULT_KILOMETERS = DEFAULT_METERS / 1000;